import React, { useEffect } from 'react'
import "./Grid.css"

const Grid = ({ id, Gkey, title, icon, imageTag, handleFavourite, handleArchive, iconTag, mediaBodyId, lastTime, description, additionalDescription, migrationInformation, moreOptions, eventMore, eventDetails, folderEvent, folderDetails, selectedIndicate = "", doubleClickHandle, status = "", dataSummary, popoverDetails, mappingEvent, urlToReplace, datasetFolderEvent, subMenuOptions, handleBreakdown, stateChange, openDataSet,tabId }) => {
    let modifiedLastTime = moment(lastTime).format("Do MMMM YYYY")
    useEffect(() => {
        // $('[data-toggle="popover"]').popover();
        feather.replace();
    }, [])

    var isReportingPage = window.location.pathname == "/start" ? true : false;
    const tabIdName = tabId
    return (
        <div className="col-sm-6 col-lg-4 col-xl-3 mg-t-10"
            id={id} key={Gkey}
            style={{ cursor: "pointer", height:"90px" }}
            onDoubleClick={doubleClickHandle
                ? () => doubleClickHandle(folderDetails,"grid",tabIdName)
                : handleBreakdown
                    ? () => handleBreakdown('dashboards', folderDetails)
                    : null}>
            <div className="media media-folder h-100"
                onClick={folderEvent ? () => folderEvent(folderDetails) : null}
                style={{ backgroundColor: selectedIndicate ? "#d3d3fb" : "",  }}>
                {imageTag
                    ? imageTag
                    : iconTag
                        ? iconTag
                        : <i className={`feather ${status}`} data-feather={icon ? icon : "folder"}></i>}
                <div className="media-body mt-0 wd-80p" id={mediaBodyId} >
                    <span className={` text-truncate wd-80p ${description != 'Custom Report' ? 'link-02' : "link-01"}`}  title={title} onClick={description != 'Custom Report' ? datasetFolderEvent ? () => datasetFolderEvent(folderDetails,"grid",null,tabIdName) : null : null}>
                        {title}
                        {/* {title.length < 30 ? title : `${title.substring(0, 26)}...`} */}
                    </span>
                    <span class={description != 'Custom Report' ? stateChange == true ? "state-change" : "" : ""} data-toggle="tooltip" onClick={description != 'Custom Report' ? datasetFolderEvent ? () => datasetFolderEvent(folderDetails,"grid",null,tabIdName)  : null : null} >{description ? description : null} {migrationInformation ? migrationInformation : null}</span>
                    <span class={stateChange == true ? "state-change" : ""} data-toggle="tooltip" onClick={openDataSet ? () => datasetFolderEvent(folderDetails,"grid",null,tabIdName)  : null}>{additionalDescription ? additionalDescription : null}</span>
                    {lastTime ? <span>{`${modifiedLastTime} (IST) `}</span> : null}
                    {dataSummary == '0' ?
                        <span className="badge badge-danger mg-l-150" style={{ color: "white" }} onClick={mappingEvent ? () => mappingEvent(folderDetails) : null}>Fix</span>
                        : null}
                </div>
                {dataSummary == 5 || moreOptions === null ? null :
                    <div className="dropdown-file">
                        <a href="#" className="dropdown-link dropdown" data-bs-toggle="dropdown"><i className="feather" data-feather="more-vertical" aria-expanded="false"></i></a>
                        <div className="dropdown-menu dropdown-menu-end">
                            {moreOptions && moreOptions.map(function (innerData, index) {
                                let newLink = innerData.url
                                    ? innerData.url.replace("_replace_name_", urlToReplace)
                                    : folderDetails.url
                                        ? folderDetails.url
                                        : null
                                return (
                                    <a className={`dropdown-item details ${innerData.subMenu ? 'dropdown-toggle' : null}`}
                                        Gkey={`elipsisMenu_${innerData.name}_${index}`}
                                        id={innerData.id}
                                        href={innerData.type == "url" ? newLink : null}
                                        target={innerData.target ? innerData.target : null}
                                        data-toggle={innerData.type == "modal" ? "modal" : null}
                                        data-target={innerData.type == "url" ? newLink : null}
                                        onClick={innerData.type == "favourite"
                                            ? () => { handleFavourite() }
                                            : innerData.type == "archive"
                                                ? () => { handleArchive() }
                                                : innerData.type == "function" && datasetFolderEvent 
                                                    ? () => datasetFolderEvent(eventDetails ? eventDetails : folderDetails,null,innerData.id,tabIdName)
                                                    : innerData.type == "function" ? () => eventMore(innerData.id, eventDetails)
                                                    : innerData.eventFunction
                                                        ? () => innerData.eventFunction(folderDetails)
                                                        : null}
                                    >
                                        <i className="feather" data-feather={innerData.icon ? innerData.icon : "info"}></i>
                                        {innerData.name}
                                    </a>
                                )
                            })}
                        </div>
                    </div>}
            </div>
        </div>
    );
}

export default Grid;